var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1949_38633",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1949_38633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 38.8346L14.417 33.3346H6.66699V25.5846L1.16699 20.0013L6.66699 14.418V6.66797H14.417L20.0003 1.16797L25.5837 6.66797H33.3337V14.418L38.8337 20.0013L33.3337 25.5846V33.3346H25.5837L20.0003 38.8346ZM20.0003 34.168L24.167 30.0013H30.0003V24.168L34.167 20.0013L30.0003 15.8346V10.0013H24.167L20.0003 5.83464L15.8337 10.0013H10.0003V15.8346L5.83366 20.0013L10.0003 24.168V30.0013H15.8337L20.0003 34.168ZM20.0003 28.3346C22.3059 28.3346 24.2712 27.5221 25.8962 25.8971C27.5212 24.2721 28.3337 22.3069 28.3337 20.0013C28.3337 17.6957 27.5212 15.7305 25.8962 14.1055C24.2712 12.4805 22.3059 11.668 20.0003 11.668V28.3346Z",
    fill: "url(#paint0_linear_1949_38633)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1949_38633",
    x1: 20.0003,
    y1: 1.16797,
    x2: 20.0003,
    y2: 38.8346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C80FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDarkMode);
export default __webpack_public_path__ + "static/media/menu-dark-mode.9193bf0e3700abfdd3b799caf6459621.svg";
export { ForwardRef as ReactComponent };